import { NewGuid } from 'utils'
import api from '@/api/comment'
export default {
  data() {
    return {
      kingGridWidArr: [],
      kingGridWidMap: new Map(),
      //用于记录当前可盖章的pos
      curOptPos: '',
      kingGridPosArr: [],
      mbRenderPosArr: []
    }
  },
  watch: {
    kingGridWidArr(arr) {
      if (!arr.length) {
        this.curOptPos = ''
      }
      this.isMobile && this.setPosVisibleState()
      this.chapterWID = arr.join(',')
      this.emitInput()
    }
  },
  methods: {
    kingGridPushWid(wid) {
      this.kingGridWidArr.push(wid)
    },
    getKingGridContentWrap(modal) {
      if (!modal) return document.createElement('div')
      return modal.$refs['elecsealWrapper']
    },
    setKingGridMap(key, val) {
      if (typeof(Signature.kingGridVmMap) !== 'undefined') {
        //用于存储sid => 组件实列
        Signature.kingGridVmMap[key] = this
      }
      this.kingGridWidMap.set(key, val)
    },
    delKingGridMap(key) {
      this.kingGridWidMap.delete(key)
    },
    clearKingGridMap() {
      this.kingGridWidMap.clear()
    },
    getKingGridMapVal(key) {
      return this.kingGridWidMap.get(key)
    },
    removeKingGridWid(wid) {
      this.kingGridWidArr = this.kingGridWidArr.filter(item => item !== wid);
    },
    generatePosArr(num) {
      let arr = []
      while (num > 0) {
        num--
        arr.push('king-grid-pos-' + NewGuid())
      }
      return arr
    },
    //能盖章的始终放在队尾
    setPosVisibleState() {
      let hasSet = false, setIndex
      for (let posObj of this.mbRenderPosArr) { 
        if (!posObj['hasChapter'] && posObj['visible']) {
          posObj['visible'] = false
        }
        if (posObj['hasChapter'] && !posObj['visible']) {
          posObj['visible'] = true
        }
      }
      for (let [index, posObj] of this.mbRenderPosArr.entries()) {
        if (!hasSet && !posObj['hasChapter']) {
          posObj['visible'] = true
          setIndex = index
          hasSet = true
          continue
        }
      }
      if (this.mbRenderPosArr.length === 2 && this.kingGridWidArr.length === 1 && setIndex === 0) {
        // const sid = this.mbRenderPosArr[1]['sid']
        if (this.mbRenderPosArr[1]['sid'] && this.KingGridElecsealIns) {
          this.KingGridElecsealIns.resetPos({sid: this.mbRenderPosArr[1]['sid'], id: this.mbRenderPosArr[0]['pos'], sdata: this.mbRenderPosArr[1]['sdata']})
          this.KingGridElecsealIns.removeDom(this.mbRenderPosArr[1]['pos'])
          this.setPosChapsterState(this.mbRenderPosArr[0]['pos'], true, { sid: this.mbRenderPosArr[1]['sid'], sdata: this.mbRenderPosArr[1]['sdata'] })
          this.setPosChapsterState(this.mbRenderPosArr[1]['pos'], false, { sid: '', sdata: null })
        }
      }
    },
    setPosChapsterState(pos, status, { sid, sdata }) {
      const mbPosItem = this.mbRenderPosArr.find(item => item.pos === pos)
      mbPosItem['hasChapter'] = status
      mbPosItem['sid'] = sid
      mbPosItem['sdata'] = sdata 
    },
    getKingGridList(kingGridIns) {
      if (!kingGridIns) return
      return new Promise((resolve) => {
        kingGridIns.getSaveSignatures().then((signs) => {
          const jsonList = eval("("+signs+")")
          resolve(jsonList)
        })
      })
    },
    querySealByWid(chapterWID) {
      return new Promise((resolve, reject) => {
        api.getSealByWid({
          wid: chapterWID
        }).then(res => {
          if (res.code === '0' && res.datas && res.datas.querySealByWids) {
            resolve(this.transformSealMap(chapterWID, res.datas.querySealByWids))
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    transformSealMap(chapterWID, map) {
      const  obj = {}
      const chapterWIDArr = chapterWID.split(',')
      const cloneMap = {}
      //调整顺序
      for (let wid of chapterWIDArr) {
        cloneMap[wid] = map[wid]
      }
      for (let [wid, value] of Object.entries(cloneMap)) {
        const [sid, sealVaild]  = value.split(',')
        obj[sid] = {
          sealVaild,
          wid
        }
      }
      return obj
    },
    signingInit(kingGridIns, chapterWID) {
      Promise.all([this.getKingGridList(kingGridIns), this.querySealByWid(chapterWID)]).then(([jsonList, sealMap]) => {
        const signdata = new Array()
        const posArray = new Array()
        let index = 0
        Object.keys(sealMap).forEach(sid => {
          const listItem = jsonList.find(childItem => childItem['signatureId'] === sid)
          if (listItem) {
            const map = {}
            const mapPos = {}
            mapPos.signatureid = map.signatureid = listItem["signatureId"]
            map.signatureData = listItem["signature"]
            signdata.push(map)
            const pos = this.kingGridPosArr[index]
            mapPos.extra = {
              position: pos
            }
            posArray.push(mapPos)
            index++
            this.setPosChapsterState(pos, true, { sid: listItem["signatureId"], sdata: listItem["signature"] })
            this.kingGridPushWid(sealMap[sid]['wid'])
            this.setKingGridMap(sid, sealMap[sid]['wid'])
          }
        })
        this.$nextTick(() => {
          this.kingGridInitLoadAndVerify(kingGridIns, { signdata, posArray, sealMap })
        })
      }).catch((err) => {
        console.log('手写签名金格模式初始化失败!', err)
      })
    },
    kingGridInitLoadAndVerify(kingGridIns, { signdata, posArray, sealMap }) {
      const _this = this;
      kingGridIns && kingGridIns.initHandleVerify(signdata, posArray, (invalidSignatureArray) => {
        let list = Signature.list
        Object.keys(list).forEach(key => {
          const signature = list[key]
          const signatureData = signature['signatureData']
          const signatureid = signature.getSignatureid()
          if (signdata.filter(item => item['signatureid'] === signatureid).length) {
            const pos = this.getSealPos(signatureData)
            let index = -1;
            invalidSignatureArray.forEach((item, idx) => {
              let id = item.getSignatureid();
              if(id === signatureid) {
                index = idx
              }
            })
            const commentItem = sealMap[signatureid]
            const signatureCreator = Signature.create()
            const sealVaild = commentItem['sealValid']
            if (index !== -1) {
              if (sealVaild == '0') {
                signatureCreator.getBase64Image(
                  signatureid,
                  signatureData,
                  pos,
                  function(fn, imgdata) {
                    const data = imgdata.join(',')
                    const WID = commentItem['wid']
                    _this.updateJGSeal({sealFile: data, wid: WID, valid: '1'}, function() {
                      signature.sealValid = false
                    })
                  })
              } else {
                signature.sealValid = false
              }
            } else {
              if (sealVaild == '1') {
                signatureCreator.getBase64Image(
                  signatureid,
                  signatureData,
                  pos,
                  function(fn, imgdata) {
                    const data = imgdata.join(',')
                    const WID = commentItem['wid']
                    _this.updateJGSeal({sealFile: data, wid: WID, valid: '0'}, function() {
                      signature.sealValid = true
                    })
                  })
              } else {
                signature.sealValid = true
              }
            }
            signature.on('_verify', function() {
              const that = this
              if(this.modified) {
                if (this.sealValid) {
                  const signatureCreator = Signature.create()
                  signatureCreator.getBase64Image(
                    signatureid,
                    signatureData,
                    pos,
                    function(fn, imgdata) {
                      const data = imgdata.join(',')
                      const commentItem = sealMap[signatureid]
                      const WID = commentItem['wid']
                      _this.updateJGSeal({sealFile: data, wid: WID, valid: '1'}, function() {
                        that.sealValid = false
                      })
                    })
                }
              } else {
                if (!this.sealValid) {
                  const signatureCreator = Signature.create()
                  signatureCreator.getBase64Image(
                    signatureid,
                    signatureData,
                    pos,
                    function(fn, imgdata) {
                      const data = imgdata.join(',')
                      const commentItem = sealMap[signatureid]
                      const WID = commentItem['wid']
                      _this.updateJGSeal({sealFile: data, wid: WID, valid: '0'}, function() {
                        that.sealValid = true
                      })
                    })
                }
              }
            })
          }
        })
      })
    }
  },
  created() {
    this.kingGridPosArr = this.generatePosArr(this.multiple ? 2 : 1)
    this.mbRenderPosArr = this.kingGridPosArr.map(pos => ({
      pos,
      visible: false,
      hasChapter: false
    }))
    this.mbRenderPosArr[0]['visible'] = true
  }
}